import ReactDOM from 'react-dom';
import getPortalElement from '~/utils/get-portal-element/get-portal-element';

interface ModalPortalProps {
  id?: string;
  children: React.ReactNode;
}

const ModalPortal: React.FC<ModalPortalProps> = ({ id, children }) => {
  return ReactDOM.createPortal(children, getPortalElement(id));
};

export default ModalPortal;
